import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  errors: FieldErrors<SubscribeFormValues>;
  required?: boolean;
  hidden?: boolean;
}

/** Independently importable — a custom layout can render this on its own. */
export default function FirstNameField({ register, errors, required, hidden }: Props) {
  if (hidden) return null;
  return (
    <div className="form-row form-row--inline js-form-item-firstname">
      <label className="form-label">Imię{required ? '*' : ''}</label>
      <input className="form-input" {...register('firstName')} />
      {errors.firstName && <div className="form-error">{errors.firstName.message}</div>}
    </div>
  );
}
